import { render, staticRenderFns } from "./SharedAlbums.vue?vue&type=template&id=10a1f9c9&scoped=true"
import script from "./SharedAlbums.vue?vue&type=script&lang=js"
export * from "./SharedAlbums.vue?vue&type=script&lang=js"
import style0 from "./SharedAlbums.vue?vue&type=style&index=0&id=10a1f9c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a1f9c9",
  null
  
)

export default component.exports